import { useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import { useSelector, useDispatch } from "react-redux";
import { goToPage } from "../redux/pageSlice";
import { connect } from "react-redux";
import { pull_trigger } from "../rightPortion/rightPortion";
import { highlight_value } from "../rightPortion/rightPortion";

function groupConsecutivePages(pages) {
  const groupedPages = [];
  let start = pages[0];
  let end = start;

  for (let i = 1; i < pages.length; i++) {
    if (pages[i] - end === 1) {
      end = pages[i];
    } else {
      groupedPages.push(start === end ? start : `${start}-${end}`);
      start = end = pages[i];
    }
  }

  groupedPages.push(start === end ? start : `${start}-${end}`);
  return groupedPages;
}

function ListComponent(props) {
  const dispatch = useDispatch();

  const handleClick = (value) => (e) => {
    let page_summary_prompt =
      "Please summarise the following pages: " + String(value);
    switch (e.detail) {
      case 1:
        console.log("single");
        dispatch(goToPage(value));
        break;
      case 2:
        console.log("double");
        pull_trigger(value);
        break;
    }
  };

  // Determine the background color based on props.name
  // to add: operative, fax, undetermined, pathology
  let backgroundColor;
  if (props.name === "radiology") {
    backgroundColor = "#89CFF0"; // Baby Blue
  } else if (props.name === "procedure") {
    backgroundColor = "#FFD700"; // Gold
  } else if (props.name === "referral") {
    backgroundColor = "#FF69B4"; // Hot Pink
  } else if (props.name === "insurance") {
    backgroundColor = "#FF4500"; // Orange Red
  } else if (props.name === "notes") {
    backgroundColor = "#ADFF2F"; // Green Yellow
  } else if (props.name === "pathology") {
    backgroundColor = "#9370DB"; // Medium Purple
  } else if (props.name === "fax") {
    backgroundColor = "#FFA07A"; // Light Salmon
  } else if (props.name === "undetermined") {
    backgroundColor = "#D3D3D3"; // Light Gray
  } else if (props.name === "lab") {
    backgroundColor = "#90EE90"; // Light Green
  }

  return (
    <>
      <div
        style={{
          boxShadow:
            "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
          padding: "10px",
          borderRadius: "10px",
          width: "95%",
          boxShadow:
            "0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)",
          borderLeft: "10px solid",
          borderColor: backgroundColor,
          backgroundColor: "white",
          marginLeft: "2%",
          marginRight: "2%",
        }}
      >
        <Typography
          variant="h6"
          component="div"
          style={{
            width: "100%",
            textAlign: "left",
            fontSize: "1rem",
            paddingLeft: "3%",
          }}
        >
          {props.name.charAt(0).toUpperCase() + props.name.slice(1)}
        </Typography>
        <List style={{ padding: "0px", width: "100%" }}>
          {props.data.map((data) => {
            return (
              <ListItem
                id={"dropdowntable" + data[0]}
                button
                key={data.id}
                onClick={handleClick(data[0])}
                value={data.page}
                style={{
                  width: "100%",
                  borderRadius: "2px",
                  borderBottom: "1px #D0D5DD solid",
                  fontSize: "2rem",
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    paddingLeft: "3px",
                    fontSize: "0.9rem",
                    color: "#1480EC",
                    fontWeight: "bold",
                    maxWidth: "75%",
                  }}
                >
                  {`  Page(s) ${groupConsecutivePages(data[0]).join(", ")}`}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {data[1]}
                </Typography>
              </ListItem>
            );
          })}
        </List>
      </div>
    </>
  );
}

export default connect()(ListComponent);
